import { render, staticRenderFns } from "./StatisticsCardSmall.vue?vue&type=template&id=36cc4be0&scoped=true&"
import script from "./StatisticsCardSmall.vue?vue&type=script&lang=js&"
export * from "./StatisticsCardSmall.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsCardSmall.vue?vue&type=style&index=0&id=36cc4be0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36cc4be0",
  null
  
)

export default component.exports